import * as React from "react";
import Cart from "./checkout/cart";
import CheckoutComponent from "./checkout/checkout";

const Checkout = () => {
    return (
        <div className="register-checkout">
            <div className="col-cart">
                <div className="inside">
                    <Cart />
                </div>
            </div>
            <div className="col-form">
                <div className="inside">
                    <CheckoutComponent />
                </div>
            </div>
        </div>
    );
};

export default Checkout;
